/*
 * DRIVLY-UI React Components
 * @license MIT
 */
function t(t,e,a){let o="";const r=t.x.translate/e.x,n=t.y.translate/e.y;if((r||n)&&(o=`translate3d(${r}px, ${n}px, 0) `),1===e.x&&1===e.y||(o+=`scale(${1/e.x}, ${1/e.y}) `),a){const{rotate:t,rotateX:e,rotateY:r}=a;t&&(o+=`rotate(${t}deg) `),e&&(o+=`rotateX(${e}deg) `),r&&(o+=`rotateY(${r}deg) `)}const s=t.x.scale*e.x,x=t.y.scale*e.y;return 1===s&&1===x||(o+=`scale(${s}, ${x})`),o||"none"}export{t as buildProjectionTransform};
//# sourceMappingURL=transform.js.map
